// src/views/kiddo-games/pairing/counterStrip.ts
// Pas u góry planszy z licznikiem plansz (np. 2 / 3): karty i obrazki tam nie trafiają, więc go nie zasłaniają
import boardClasses from './KiddoPairingView.module.less';

const GAP_BELOW_COUNTER = 10; // px — z zapasem na lekki obrót karty

// Dolna krawędź pasa, liczona od góry #main, tak jak left/top kart. Licznik jest dopiero przy dwóch planszach —
// bez niego pasa nie ma (0)
const getCounterStripBottom = (): number => {
  const counter = document.querySelector<HTMLElement>(`.${boardClasses.pages}`);

  return counter ? counter.offsetTop + counter.offsetHeight + GAP_BELOW_COUNTER : 0;
};

export default getCounterStripBottom;
